import React, { useEffect } from 'react';
import './LanguageSelect.css';
import { useTranslation } from "react-i18next";
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';

const LANGUAGES = [
    { code: 'ee', label: 'Estonian', flag: '/images/flags/estonia_flag.png' },
    { code: 'en', label: 'English', flag: '/images/flags/us_flag.jpg' },
    { code: 'cr', label: 'Croatian', flag: '/images/flags/croatia-flag.jpg' },
    { code: 'gr', label: 'Greek', flag: '/images/flags/greece-flag.png' }, // Lisa siia õige tee kreeka lipuni
];

export default function LanguageSelect({ width }) {
    const { t, i18n } = useTranslation();
    
    // Määrame praeguse keele (fallback inglise keelele, kui i18n.language on tühi)
    const currentLangCode = i18n.language || "en";
    const currentLang = LANGUAGES.find(l => l.code === currentLangCode) || LANGUAGES[1];

    useEffect(() => {
        const savedLng = localStorage.getItem("i18nextLng");
        if (savedLng) {
            i18n.changeLanguage(savedLng);
        }
    }, [i18n]);

    const changeLanguage = (lng) => {
        localStorage.setItem("i18nextLng", lng);
        i18n.changeLanguage(lng);
    }

    const dropdownTitle = (
        <>
             <img
                src={currentLang.flag}
                className="ml-2"
                height="16"
                width="24"
                alt={currentLang.label}
            />
            
           
            <i className="mdi mdi-chevron-down ml-1"></i>
        </>
    );

    return (
        <Nav>
            <NavDropdown className="custom-dropdown" title={dropdownTitle}>
                {LANGUAGES.filter(l => l.code !== currentLangCode).map((lang) => (
                    <NavDropdown.Item key={lang.code} onClick={() => changeLanguage(lang.code)}>
                        <img
                            src={lang.flag}
                            alt=""
                            className="ml-2 float-right"
                            height="14"
                            width="21"
                        />
                        <span>{t(lang.label)}</span>                        
                    </NavDropdown.Item>
                ))}
            </NavDropdown>
        </Nav>
    );
}